// extracted by mini-css-extract-plugin
export default {"educationContainer":"Education_educationContainer__+PaFw","heading":"Education_heading__ol2N1","education":"Education_education__47KTv","line":"Education_line__0kRN0"};